module.exports = __webpack_public_path__ + "static/img/122.e43f2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/122.png
// module id = fJgM
// module chunks = 0